// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useContext} from 'react';
// @ts-ignore
import {align, days_short, strftime} from '/util/date.js';
import styles from './month.module.less';
import cn from 'classnames';
import {Settings_context} from '../../settings_ctx';

interface i_month_props {
    value?: Date;
    period?: {start: Date; end: Date, hover?: Date}
    on_change: (value:Date)=>void;
    view_month?: number;
    view_year?: number;
    min_date?: Date;
    on_hover_date?: (value:Date)=>void;
    no_head?: boolean;
    head_only?: boolean;
    dateonly?: boolean;
}
export const Month = ({value, period, on_change, view_month, view_year,
    min_date, on_hover_date, no_head, head_only, dateonly}
    :i_month_props)=>{
    const {theme} = useContext(Settings_context);
    const aligned = view_month!==undefined
        ? new Date(view_year, view_month, 1) : align(value, 'MONTH');
    const start_day = aligned.getDay();
    const month = view_month!==undefined ? view_month : aligned.getMonth() + 1;
    const year = view_year ? view_year : aligned.getFullYear();
    const days_in_prev_month = new Date(year, month, 0).getDate();
    const days_in_month = new Date(year, month+1, 0).getDate();
    let period_start = period?.start || null;
    let period_end = period?.end || null;
    let period_hover = period?.hover || null;
    if (period_hover && period_hover>period_start)
        period_end = period_hover;
    else if (period_hover && period_hover<period_start)
    {
        period_end = period_start;
        period_start = period_hover;
    }
    const possible_selected = [
        period_start ? strftime('%d-%b-%y', period_start, {local: true}) : 0,
        period_end ? strftime('%d-%b-%y', period_end, {local: true}) : 0,
        value ? strftime('%d-%b-%y', value, {local: true}) : 0,
    ];
    const days = [];
    for (let i=0;i<start_day;i++)
    {
        const prev_month = month > 1 ? month - 2 : 11;
        const prev_year = prev_month > month ? year - 1 : year;
        const day = days_in_prev_month-start_day+i+1;
        const day_date = new Date(prev_year, prev_month+1, day);
        // const in_period = period_start && period_end &&
        // day_date >= period_start && day_date <= period_end;
        days.push({month: prev_month, current_month: false, day, day_date});
    }
    for (let i=0;i<days_in_month;i++){
        const current_day = i + 1;
        const day_date = new Date(year, month, current_day);
        const selected_index = possible_selected.indexOf(strftime('%d-%b-%y',
          day_date, {local: true}));
        const in_period = period_start && period_end &&
            day_date >= period_start && day_date <= period_end;
            days.push({month: month-1, day: i+1,
                current_month: !min_date || min_date<day_date,
                day_date,
                color: selected_index>-1 ? cn(
                        selected_index==0 && styles.selected_start,
                        selected_index==1 && styles.selected_end,
                        selected_index==2 && styles.selected
                    ) :
                    in_period ? cn(styles.in_period,
                    current_day==1 && styles.begin_of_month,
                    days_in_month==current_day && styles.end_of_month) : ''});
    }
    const count = 7 - days.length % 7;
    for (let i=1;i<=count;i++){
        const next_month = month==12 ? 0 : month;
        const next_year = next_month < month ? year + 1 : year;
        const day_date = new Date(next_year, next_month+1, i);
        // const in_period = period_start && period_end &&
        //    day_date >= period_start && day_date <= period_end;
        days.push({month: next_month, day: i,
            color: '',
            current_month: false, day_date});
    }
    const cls = cn(styles.root_month, dateonly && styles.dateonly);
    return <div className={cls} key={`${month}_${year}`}>
      {no_head ? null : days_short.map(d=><div className={cn(theme.p3,
        theme.reg, styles.cell, styles.week_day)} data-elem="week_day"
        key={d}>{d.substr(0, 2)}</div>)}
      {head_only ? null : days.map(d=>{
        return <button aria-label={'Select '+strftime('%d-%b-%y',
          d.day_date, {local: true})} key={strftime('%d-%b-%y',
          d.day_date, {local: true})} className={cn(theme.p3, theme.reg,
          styles.cell, !d.current_month && styles.inactive,
          d.color)} data-elem="cell"
          onClick={()=>{
            on_change(d.day_date);
          }} onMouseEnter={()=>{
            if (on_hover_date)
              on_hover_date(d.day_date);
          }}>{d.day}</button>;
      })}
    </div>;
};
